<template>
  <VListItem
    key="settings"
    link
    :to="{ name: 'settings' }"
    :class="{ 'close' : miniVariant }"
    @click="$emit('itemSelect')"
  >
    <VListItemContent class="d-block">
      <VListItemTitle
        :class="miniVariant
          ? 'd-block' : 'd-flex align-center flex-row justify-start flex-nowrap'"
      >
        <div class="menu-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_1099_721)">
              <path d="M9 12C12.309 12 15 9.309 15 6C15 2.691 12.309 0 9 0C5.691 0 3 2.691 3 6C3 9.309 5.691 12 9 12ZM9 2C11.206 2 13 3.794 13 6C13 8.206 11.206 10 9 10C6.794 10 5 8.206 5 6C5 3.794 6.794 2 9 2ZM23.122 11.879C21.988 10.745 20.012 10.745 18.879 11.879L11 19.757V24H15.243L23.121 16.122C23.688 15.555 24 14.802 24 14C24 13.198 23.688 12.445 23.122 11.879ZM21.707 14.707L14.415 22H13V20.585L20.293 13.293C20.67 12.915 21.329 12.915 21.707 13.293C21.896 13.481 22 13.732 22 14C22 14.268 21.896 14.518 21.707 14.707ZM11.929 16H5C3.346 16 2 17.346 2 19V24H0V19C0 16.243 2.243 14 5 14H13C13.289 14 13.568 14.038 13.844 14.085L11.929 16Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_1099_721">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        {{ $t('account') }}
      </VListItemTitle>
    </VListItemContent>
  </VListItem>
</template>

<script>
export default {
  name: 'TheMenuSettings',
  props: {
    miniVariant: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  .v-list-item {
    &::after {
      display: none;
    }
  }

  .v-list-item__content::v-deep {
    padding: 10px !important;
    @media screen and (max-width: 1650px) {
      padding: 5px !important;
    }
    @media screen and (max-width: 600px) {
      padding: 3px 12px 3px 12px !important;
    }
    @media screen and (max-width: 320px) {
      padding: 0px 7px 0px 7px !important;
    }

    .v-list-item__title {
      @media screen and (max-width: 599px) {
        font-weight: 600;
        font-size: 20px !important;
        line-height: 100%;
      }
      @media screen and (max-width: 320px) {
        font-size: 16px !important;
      }
      .menu-icon {
        @media screen and (max-width: 599px) {
          width: 18px;
        }
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  account: Account
</i18n>

<i18n locale="ru" lang="yaml">
  account: Аккаунт
</i18n>
